<div class="container" style="min-height: 650px;" >
  <div class="row">
    <div class="col-12 mt-5">
      <label class="header-text">Prescriptions - United Networks of America</label>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
     <p class="text-sm-poppins">
       As a member, you have access to prescription drug savings between 15% to 60% off the retail price of generic drugs and 10% to 25% off the retail price of brand name drugs at over 68,000 participating pharmacies nationwide including, Safeway, CVS, Duane Reade, Wal-Mart, Target, Walgreens, Rite Aid and many more.
     </p>
     <p class="text-sm-poppins">
       For information regarding ancillary benefits including UNOA please visit <a href="http://smilegen.solutionssimplified.com" target="_blank">smilegen.solutionssimplified.com</a> .
     </p>
    </div>
  </div>
  <div class="row">
    <div class="col-12 mt-5 mb-5"></div>
  </div>
</div>
